var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',_vm._g({staticClass:"btn-secondary",attrs:{"text":_vm.text}},_vm.$listeners),[(_vm.iconClass)?_c('i',{class:_vm.iconClass}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }